import React from "react";
import { motion } from "framer-motion";
import "./AboutBanner.css";
import personImg from "../Assets/contact_person.png";
import overlayShape from "../Assets/Triangle.png";

const ContactBanner = () => {
  return (
    <section className="Contact-banner">
      {/* Content Section */}
      <motion.div
        className="banner-content"
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        <motion.h1
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          Let’s<span> Start the </span>  Conversation
        </motion.h1>

        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          Start the conversation today, build connections that last a lifetime.
        </motion.p>

      </motion.div>

      {/* Image Section */}
      <motion.div
        className="banner-images"
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.2, duration: 1 }}
      >
        <motion.img
          src={overlayShape}
          alt="Overlay Shape"
          className="overlay-shape"
          initial={{ rotate: -180, opacity: 0 }}
          animate={{ rotate: 0, opacity: 1 }}
          transition={{ delay: 1.5, duration: 1 }}
        />
        <motion.img
          src={personImg}
          alt="Person"
          className="person-img"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1.8, duration: 1 }}
        />
      </motion.div>
    </section>
  );
};

export default ContactBanner;
